import { useApp } from '../../context/AppContext';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { RightDrawer } from './RightDrawer';
import { cn } from '../../lib/utils';

export const Shell = ({ children }) => {
  const { sidebarCollapsed } = useApp();

  return (
    <div className="crm-layout">
      <Sidebar />
      <main className={cn('crm-main', sidebarCollapsed && 'sidebar-collapsed')}>
        <Header />
        <div className="crm-content scrollbar-thin">
          {children}
        </div>
      </main>
      <RightDrawer />
    </div>
  );
};

export default Shell;
